import { gql, useLazyQuery } from '@apollo/client';

export const GENERATE_INVOICES = gql`
  query GenerateInvoices($order_ids: [Int!]!) {
    generateInvoices(order_ids: $order_ids) {
      download_url
      message
      mime_type
      success
    }
  }
`;
